export enum WellAnnotationType
    {
        FormationTop = 0,
        FormationTest = 1,
        Hydrocarbon = 2,
    }